import * as apiGet from 'api/userSetting/GetUserSettingKeyV1';
import * as apiPut from 'api/userSetting/PutUserSettingKeyV1';
import { AllergenLogic } from 'enums/allergenLogic';
import { ValueScope } from 'enums/valueScope';
import * as ValueScopeList from 'types/User/UserProfile/ValueScopeList';

export type Type = {
	'Price.Currency'?: string;
	'Recipe.List.ValueScope': ValueScope;
	'Recipe.Nutrient.Columns': ValueScopeList.Type;
	'Preferred.Nutrient.Ids': string[];
};

export type PreferredAllergen = {
	id: string;
	logic: AllergenLogic;
};

export type UserSettingsApi = {
	'Price.Currency'?: string;
	'Recipe.List.ValueScope': ValueScope;
	'Preferred.Nutrient.Ids'?: string;
};

export function create(): Type {
	return {
		'Recipe.List.ValueScope': ValueScope.Person,
		'Recipe.Nutrient.Columns': ValueScopeList.create(),
		'Preferred.Nutrient.Ids': [],
	};
}

export function setRecipeNutrientColumns(obj: Type, key: ValueScope): Type {
	return {
		...obj,
		'Recipe.Nutrient.Columns': ValueScopeList.update(obj['Recipe.Nutrient.Columns'], key),
	};
}

export async function putRecipeNutrientColumnsToApi(obj: Type): Promise<void> {
	await apiPut.callApi('Recipe.Nutrient.Columns', obj['Recipe.Nutrient.Columns'].join(';'));
}

export function putNutrientIdsToApi(obj: Type) {
	apiPut.callApi('Preferred.Nutrient.Ids', obj['Preferred.Nutrient.Ids'].join(';'));
}

export async function getRecipeListValueScopeFromApi(obj: Type): Promise<Type> {
	const response = await apiGet.callApi('Recipe.List.ValueScope');
	const responseData = response.toNullable();
	if (!responseData) return obj;
	return {
		...obj,
		'Recipe.List.ValueScope': responseData as ValueScope,
	};
}

export async function getRecipeNutrientColumnsFromApi(obj: Type): Promise<Type> {
	const response = await apiGet.callApi('Recipe.Nutrient.Columns');
	const responseData = response.toNullable();
	if (!responseData) return obj;
	return {
		...obj,
		'Recipe.Nutrient.Columns': responseData.split(';').map((e) => e as ValueScope),
	};
}

export async function getNutrientIdsFromApi(obj: Type): Promise<Type> {
	const response = await apiGet.callApi('Preferred.Nutrient.Ids');
	const responseData = response.toNullable();
	if (!responseData) return obj;
	return {
		...obj,
		'Preferred.Nutrient.Ids': responseData.split(';'),
	};
}

export function mapFromApi(userSettingsApi: UserSettingsApi): Type {
	var userSettings: Type = create();

	if (userSettingsApi['Price.Currency']) {
		userSettings['Price.Currency'] = userSettingsApi['Price.Currency'];
	}
	if (userSettingsApi['Recipe.List.ValueScope']) {
		userSettings['Recipe.List.ValueScope'] = userSettingsApi['Recipe.List.ValueScope'];
	}
	if (userSettingsApi['Preferred.Nutrient.Ids']) {
		userSettings['Preferred.Nutrient.Ids'] =
			userSettingsApi['Preferred.Nutrient.Ids'].split(';');
	}

	return userSettings;
}

export function mapToApi(userSettings: Type | null): UserSettingsApi | null {
	if (!userSettings) {
		return null;
	}

	var userSettingsToApi: UserSettingsApi = {
		'Recipe.List.ValueScope': ValueScope.Person,
	};

	if (userSettings['Price.Currency']) {
		userSettingsToApi['Price.Currency'] = userSettings['Price.Currency'];
	}
	if (userSettings['Recipe.List.ValueScope']) {
		userSettingsToApi['Recipe.List.ValueScope'] = userSettings['Recipe.List.ValueScope'];
	}
	if (
		userSettings['Preferred.Nutrient.Ids'] &&
		userSettings['Preferred.Nutrient.Ids'].length != 0
	) {
		userSettingsToApi['Preferred.Nutrient.Ids'] =
			userSettings['Preferred.Nutrient.Ids'].join(';');
	}

	return userSettingsToApi;
}
